/**
 * WordPress dependencies
 * @wordpress/i18n for translation functions
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 * - Should basically always be used for any text that is visible to the user
 *
 * @wordpress/element for React components
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-element/
 */
import { __ } from '@wordpress/i18n';
import { decodeEntities } from '@wordpress/html-entities';

import { handleEuneosRegisterClick, checkIfRegistrable } from '@utils';

/**
 * CourseListItem Component
 * @param {Object} props
 * @returns {JSX.Element}
 */
function CourseRowItem({ id, name, url, start, end, status, registrationUrl }) {
	const formatter = new Intl.DateTimeFormat('fi', {
		day: 'numeric',
		month: 'numeric',
		year: 'numeric',
	});

	const startDate = start ? formatter.format(new Date(start)) : 'On Demand';
	const endDate = end ? ' - ' + formatter.format(new Date(end)) : '';

	return (
		<tr className="upcoming-instances__row">
			<td>
				{startDate}
				{endDate}
			</td>
			<td colSpan={2}>
				<a href={url} target="_blank" rel="noopener noreferrer">
					{decodeEntities(name)}
				</a>
			</td>
			<td>{decodeEntities(status[0]?.name)}</td>
			<td>
				{checkIfRegistrable({ status }) && (
					<a
						href={registrationUrl}
						target="_blank"
						rel="noopener noreferrer"
						data-track="true"
						data-track-event="link_click"
						data-track-action="register"
						data-track-label={id}
						onClick={() => handleEuneosRegisterClick(id)}
					>
						Register Now
					</a>
				)}
			</td>
		</tr>
	);
}

export default CourseRowItem;
